/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { scrollToAnchor } from "../../../../theme/commonStyle";

const controlledAccordionSectionStyle = {
  headline: {
    textAlign: "center",
    marginBottom: "3rem",
  },
  scrollToAnchor,
};

export default controlledAccordionSectionStyle;
